import { render } from "./CompProgress.vue?vue&type=template&id=5b1e2f56"
import script from "./CompProgress.vue?vue&type=script&lang=js"
export * from "./CompProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__